export default __webpack_public_path__ + "static/media/save.677f91fa.svg";